var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "college_detail" }, [
    _vm.$route.query.isApp
      ? _c(
          "header",
          [
            _c("van-icon", {
              attrs: { name: _vm.isDirection ? "arrow" : "arrow-left" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$router.push({
                    path: _vm.$route.query.path,
                    query: {
                      id: _vm.$route.query.categoryid,
                      activeid: _vm.$route.query.activeid,
                      isApp: _vm.$route.query.isApp,
                      language: _vm.$route.query.language
                    }
                  })
                }
              }
            }),
            _vm._v(" "),
            _c("i", {
              staticClass: "icon-fenxiang iconfont",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleShare.apply(null, arguments)
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("main", [
      _c(
        "div",
        {
          staticClass: "commont_body",
          on: {
            touchmove: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("dl", [
            _c("dt", [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.data.imgs,
                    expression: "data.imgs"
                  }
                ],
                attrs: { src: _vm.data.imgs, alt: "" }
              })
            ]),
            _vm._v(" "),
            _c("dd", [
              _c("div", { staticClass: "title" }, [
                _c("b", [_vm._v(_vm._s(_vm.data.title))])
              ]),
              _vm._v(" "),
              !_vm.$route.query.istime
                ? _c("div", { staticClass: "release" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.parsetime(_vm.data.releaseTime, "{y}/{m}/{d}")
                        ) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "content",
            domProps: { innerHTML: _vm._s(_vm.data.content) }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [_c("div")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed73748e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed73748e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/college/details.vue
// module id = vzi6
// module chunks = 0